const DEFAULT_MAX_ATTEMPTS = 2;
const DEFAULT_RETRY_DELAY_MS = 200;

function isValidCarTypeList(list) {
  return Array.isArray(list) && list.length > 0 && list.every(
    (item) => item && typeof item.value === 'string' && typeof item.name === 'string'
  );
}

async function loadCarTypes(fetchCarTypes, options = {}) {
  const maxAttempts = options.maxAttempts || DEFAULT_MAX_ATTEMPTS;
  const retryDelayMs = options.retryDelayMs === undefined
    ? DEFAULT_RETRY_DELAY_MS
    : options.retryDelayMs;
  const delay = options.delay || ((milliseconds) => new Promise(
    resolve => setTimeout(resolve, milliseconds)
  ));
  let lastError;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      const response = await fetchCarTypes();
      const list = response && response.result;
      if (!(options.validate || isValidCarTypeList)(list)) {
        throw new Error('ข้อมูลประเภทรถจากระบบไม่ถูกต้อง');
      }
      return list;
    } catch (error) {
      lastError = error;
      const status = error && error.response && error.response.status;
      const canRetry = attempt + 1 < maxAttempts && (!status || status >= 500);
      if (!canRetry) break;
      await delay(retryDelayMs);
    }
  }

  const loadError = new Error('ไม่สามารถโหลดรายการประเภทรถได้ กรุณาลองใหม่อีกครั้ง');
  loadError.originalError = lastError;
  throw loadError;
}

module.exports = { isValidCarTypeList, loadCarTypes };
